import EndpointFactory from '~~/app/factories/EndpointFactory';
import TenantEndpoint from '~~/app/auth/endpoints/TenantEndpoint';
import { ModelType } from '~~/app/base/schemas/BaseSchema';
import { TENANT_ACCESS_ERROR_PAGES } from '~~/app/auth/enums/TenantAccessError';
import { fetchTenantWhileUnavailable } from '~~/app/auth/tenant-availability';

export default async ({ onDemoSeeding }: { onDemoSeeding?: () => void } = {}): Promise<string | void> => {
    const { setTenant, setInaccessibleTenantPath } = useAuthStore();

    // Reset so the stored path always reflects the latest fetch (e.g. after reactivation).
    setInaccessibleTenantPath(null);

    const endpoint = EndpointFactory.make(ModelType.TENANTS) as TenantEndpoint;
    const response = await fetchTenantWhileUnavailable(() => endpoint.default(), wait, { onDemoSeeding });

    /**
     * The user doesn't have a tenant, redirect to the tenant registration page (default behaviour).
     */
    if (response && response.response && response.response.status === 404) {
        return;
    }

    /**
     * A specific error was thrown, redirect to the appropriate page.
     */
    if (response.error) {
        console.error('Failed to retrieve tenant.', response, response.error, Array.isArray(response.error));
        if (Array.isArray(response.error)) {
            const error = response.error[0];
            const tenantId = error.meta?.tenant;
            const page = error.detail ? TENANT_ACCESS_ERROR_PAGES[error.detail] : undefined;
            if (tenantId && page) {
                const path = `/auth/tenant/${tenantId}/${page}`;
                setInaccessibleTenantPath(path);
                return path;
            }
        }
    }

    if (!response.data) {
        return `/auth/tenant/error`;
    }

    /**
     * Access refused, but the tenant still came back thanks to the
     * X-Worksite-Access-Signal header (TDD-5631): cancelled and paused route to
     * their dedicated screens (the 403 fallback above cannot tell them apart,
     * both share the cancelled detail). An unpaid_blocked tenant loads the app
     * normally: unpaid-blocked.global.ts confines it to /settings/invoices.
     */
    const accessDeniedReason = response.data.unpaidAccessDeniedReason;
    if (accessDeniedReason === 'cancelled' || accessDeniedReason === 'paused') {
        const path = `/auth/tenant/${response.data.getId()}/${accessDeniedReason}`;
        setInaccessibleTenantPath(path);
        return path;
    }

    setTenant(response.data);

    // let users = authStore.tenant?.included.map(tenantUser => {
    //     tenantUser.type = 'users';
    //     return tenantUser;
    // });
    // authStore.users = new UserCollection(users);
};
